import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../../utilities/modalHOC';
import { getPermissions, getUser } from '../../../Login/selectors';
import {
  noGroups,
  setActiveStatus,
  setAdminByQual,
  setAdminByRate,
  setAdminScroll,
  setAwaitingForApproval,
  setIsBackFromQuestion,
  setIsChangingType,
  setIsViewRates,
  setLoading,
  setSelectedAdminAndRate,
  updateStudyProgramAdmins,
} from '../../actions';
import {
  getAllQualsAdmins,
  getAllRatesAdmins,
  getAssignmentsCount,
  getAwaitingApproval,
} from '../../actionsSagas';
import {
  getActiveStatus,
  getAdminsByQual,
  getAdminsByQualI,
  getAdminsByRate,
  getAdminsByRateI,
  getAdminScroll,
  getAwaitingApproval as getAwaitingApprovalSelector,
  getIsBackFromQuestion,
  getIsViewRates,
  getSelectedAdmin,
  getSelectedRate,
  getStudyProgramAdmins,
} from '../../selectors';
import GroupsList from './GroupsList';

const mapStateToProps = (state, ownProps) => ({
  adminsByRate: getAdminsByRate(state),
  adminsByQual: getAdminsByQual(state),
  selectedAdmin: getSelectedAdmin(state),
  selectedRate: getSelectedRate(state),
  isViewRates: getIsViewRates(state),
  user: getUser(state),
  activeStatus: getActiveStatus(state),
  awaitingApproval: getAwaitingApprovalSelector(state),
  permissions: getPermissions(state),
  adminsByRateImmutable: getAdminsByRateI(state),
  adminsByQualImmutable: getAdminsByQualI(state),
  studyProgramAdmins: getStudyProgramAdmins(state),
  adminScroll: getAdminScroll(state),
  isBackFromQuestion: getIsBackFromQuestion(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLoadAdmins: (
    getInactiveAdmins,
    removingApprovalFilter = false,
    isSetAdmin,
  ) => {
    dispatch(setAwaitingForApproval(false));
    dispatch(
      getAllRatesAdmins(getInactiveAdmins, removingApprovalFilter, isSetAdmin),
    );
  },
  onLoadAdminsQuals: (getInactiveAdmins) => {
    dispatch(getAllQualsAdmins(getInactiveAdmins));
  },
  onSelectAdmin: (admin, rate) => {
    dispatch(setSelectedAdminAndRate(admin, rate));
  },
  onChangeView: (newView) => {
    dispatch(setIsViewRates(newView));
  },
  updateIsChangingType: (value) => {
    dispatch(setIsChangingType(value));
  },
  updateLoading: (loading) => {
    dispatch(setLoading(loading));
  },
  getAwaitingApproval: () => {
    dispatch(setActiveStatus('awaitingApproval'));
    dispatch(setAwaitingForApproval(true));
    dispatch(setSelectedAdminAndRate(null, null));
    dispatch(getAwaitingApproval());
  },
  setActiveStatus: (status) => {
    dispatch(setActiveStatus(status));
  },
  setAwaitingForApproval: (value) => {
    dispatch(setAwaitingForApproval(value));
  },
  setAssignmentsCount: (admin, rate, type) => {
    dispatch(getAssignmentsCount(admin.id, rate, type));
  },
  updateStudyProgramAdmins: (admins) => {
    dispatch(updateStudyProgramAdmins(admins));
  },
  noGroups: (value) => {
    dispatch(noGroups(value));
  },
  setAdminScroll: (y) => {
    dispatch(setAdminScroll(y));
  },
  setIsBackFromQuestion: (isBackFromQuestion) => {
    dispatch(setIsBackFromQuestion(isBackFromQuestion));
  },
  onClearAdmins: () => {
    dispatch(setAdminByQual([]));
    dispatch(setAdminByRate([]));
    dispatch(updateStudyProgramAdmins([]));
  },
});

const GroupsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupsList);

export default addAbilityToOpenModal(GroupsListContainer);
